import React, { FunctionComponent } from 'react';
import { Route } from 'react-router-dom';
import routes from 'routes/admin';

interface IAdmin {}

const Admin: FunctionComponent<IAdmin> = () => {
  return (
    <>
      {routes.map(({ path, Component }, key) => (
        <Route exact path={path} key={key} component={Component} />
      ))}
    </>
  );
};

export default Admin;
